import { DateTime } from 'luxon'

import { dateTimeFormats } from '@theme/variables'

import { CellInfo } from '../types'

export const CreatedAtCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
  } = info

  return <div>{DateTime.fromISO(profileData.createdAt).toFormat(dateTimeFormats.eventDateFormat)}</div>
}
